import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import storage from "../apis/Storage";

const checkPageAccess = (path, permittedPages, role) => {
  let isUserAuthorised = false;
  let allowedActions = [];
  let selectedPageName = [];
debugger;
  // Administrators always have access
  if (role === "Administrator" || role === "RsoAdmin") {
    return {
      isUserAuthorised: true,
      allowedActions: [],
    };
  }

  if (Array.isArray(permittedPages) && permittedPages.length > 0) {
    // If permittedPages exists
    isUserAuthorised = permittedPages.find((page) => page.pageUrl.toLowerCase() === path.toLowerCase())
    if (!isUserAuthorised && path.includes('/:')) {
      const basePath = path.split('/:')[0]
      isUserAuthorised = permittedPages.find((page) => page.pageUrl.toLowerCase() === basePath.toLowerCase())
    }
    permittedPages.forEach((element) => {
      // If Url exists
      if (element.pageUrl.toLowerCase() == path.toLowerCase()) {
        // If Action exists
        var anyPermittedAction = element.actions.filter(
          (x) => x.isSystemAction == true || x.ischecked
        )
        if (
          Array.isArray(element.actions) &&
          element.actions.length > 0 &&
          anyPermittedAction.length > 0
        ) {
          // Prepare Action List
          element.actions.forEach((item) => {
            allowedActions.push(item)
          })
        }
      }
    })

  }

  return {
    isUserAuthorised,
    allowedActions,
  };
};

const _ProtectedRoute = ({
  component: Component,
  path,
  permittedPages,
  appToken,
  userRole,
  ...rest
}) => {
  const checkAccess = checkPageAccess(path, permittedPages, userRole);
  return (
    <Route
      {...rest}
      render={(props) => {
        // User not logged in
        if (!appToken) {
          return <Redirect to="/login" />;
        }

        // User logged in but does not have permission
        if (!checkAccess.isUserAuthorised) {
          return (
            <div className="container mt-5 text-center">
              <h3>Access Denied</h3>
              <p>
                You do not have permission to access <b>"{path}"</b> page.
              </p>
            </div>
          );
        }

        return (
          <Component
            {...props}
            actions={checkAccess.allowedActions}
            path={path}
          />
        );
      }}
    />
  );
};

const mapStateToProps = () => {
  let permittedPages = [];

  try {
    permittedPages = JSON.parse(storage.get("_userPermissionsList") || "[]");
  } catch (error) {
    console.error("Error parsing permissions:", error);
    permittedPages = [];
  }

  return {
    permittedPages,
    appToken: storage.get("_appToken"),
    userRole: storage.get("_appUserRole"),
  };
};

const RestrictedRoute = connect(mapStateToProps)(_ProtectedRoute);

export default RestrictedRoute;
